import { StylePropertyDefinition } from '../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [
	{
		n: 'bodyBackground',
		dn: 'Application/Site Background',
		de: 'This is the application level background',
		np: true,
		cp: 'background',
		sel: 'body',
	},
	{
		n: 'bodyMargin',
		dn: 'Application/Site Body Margin',
		de: 'This is the application level body margin',
		np: true,
		cp: 'margin',
		sel: 'body',
		dv: '0',
	},
	{
		n: 'bodyFont',
		dn: 'Application/Site Font',
		de: 'This is the application level font',
		np: true,
		cp: 'font',
		sel: 'body',
		dv: '<primaryFont>',
	},
	{
		n: 'scrollBarWidth',
		dn: 'Scroll bar width',
		de: 'Scroll bar width',
		np: true,
		cp: 'width',
		sel: '::-webkit-scrollbar',
		dv: '7px',
	},
	{
		n: 'scrollBarHeight',
		dn: 'Scroll bar height',
		de: 'Scroll bar height',
		np: true,
		cp: 'height',
		sel: '::-webkit-scrollbar',
		dv: '7px',
	},
	{
		n: 'scrollBarThumbBg',
		dn: 'Scroll bar thumb background',
		de: 'Scroll bar thumb background',
		np: true,
		cp: 'background',
		sel: '::-webkit-scrollbar-thumb',
		dv: '#a3b2c0',
	},
	{
		n: 'scrollBarThumbBorderRadius',
		dn: 'Scroll bar thumb border radius',
		de: 'Scroll bar thumb border radius',
		np: true,
		cp: 'border-radius',
		sel: '::-webkit-scrollbar-thumb, ::-webkit-scrollbar-corner',
		dv: '3px',
	},
	{
		n: 'scrollBarHoverWidth',
		dn: 'Scroll bar hover width',
		de: 'Scroll bar hover width',
		np: true,
		cp: 'width',
		sel: '*:hover::-webkit-scrollbar',
		dv: '7px',
	},
	{
		n: 'scrollBarThumbHoverBg',
		dn: 'Scroll bar hover thumb background',
		de: 'Scroll bar hover thumb background',
		np: true,
		cp: 'background',
		sel: '*:hover::-webkit-scrollbar-thumb',
		dv: '#6d8499',
	},
	{
		n: 'iconThinnerWeight',
		dn: 'Icon Thinner Weight',
		de: 'Icon Thinner Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._thinner, .mi._thinner, .ms._thinner',
		dv: '100',
	},
	{
		n: 'iconThinWeight',
		dn: 'Icon Thin Weight',
		de: 'Icon Thin Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._thins, .mi._thins, .ms._thins',
		dv: '200',
	},
	{
		n: 'iconLightWeight',
		dn: 'Icon Light Weight',
		de: 'Icon Light Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._light, .mi._light, .ms._light',
		dv: '300',
	},
	{
		n: 'iconRegularWeight',
		dn: 'Icon Regular Weight',
		de: 'Icon Regular Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._regular, .mi._regular, .ms._regular',
		dv: '400',
	},
	{
		n: 'iconMediumWeight',
		dn: 'Icon Medium Weight',
		de: 'Icon Medium Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._medium, .mi._medium, .ms._medium',
		dv: '500',
	},
	{
		n: 'iconSemiBoldWeight',
		dn: 'Icon Semi Bold Weight',
		de: 'Icon Semi Bold Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._semiBold, .mi._semiBold, .ms._semiBold',
		dv: '600',
	},
	{
		n: 'iconBoldWeight',
		dn: 'Icon Bold Weight',
		de: 'Icon Bold Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._bold, .mi._bold, .ms._bold',
		dv: '700',
	},
	{
		n: 'iconExtraBoldWeight',
		dn: 'Icon Extra Bold Weight',
		de: 'Icon Extra Bold Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._extraBold, .mi._extraBold, .ms._extraBold',
		dv: '800',
	},
	{
		n: 'iconBlackWeight',
		dn: 'Icon Black Weight',
		de: 'Icon Black Weight',
		np: true,
		cp: 'font-weight',
		sel: '.fa._black, .mi._black, .ms._black',
		dv: '900',
	},

	{
		n: 'iconSize1',
		dn: 'Icon Size 1',
		de: 'Icon Size 1',
		np: true,
		cp: 'font-size',
		sel: '.fa._size1, .mi._size1, .ms._size1',
		dv: '24px',
	},
	{
		n: 'iconSize2',
		dn: 'Icon Size 2',
		de: 'Icon Size 2',
		np: true,
		cp: 'font-size',
		sel: '.fa._size2, .mi._size2, .ms._size2',
		dv: '36px',
	},
	{
		n: 'iconSize3',
		dn: 'Icon Size 3',
		de: 'Icon Size 3',
		np: true,
		cp: 'font-size',
		sel: '.fa._size3, .mi._size3, .ms._size3',
		dv: '48px',
	},
	{
		n: 'iconSize4',
		dn: 'Icon Size 4',
		de: 'Icon Size 4',
		np: true,
		cp: 'font-size',
		sel: '.fa._size4, .mi._size4, .ms._size4',
		dv: '60px',
	},
	{
		n: 'iconSize5',
		dn: 'Icon Size 5',
		de: 'Icon Size 5',
		np: true,
		cp: 'font-size',
		sel: '.fa._size5, .mi._size5, .ms._size5',
		dv: '72px',
	},
	{
		n: 'iconSize6',
		dn: 'Icon Size 6',
		de: 'Icon Size 6',
		np: true,
		cp: 'font-size',
		sel: '.fa._size6, .mi._size6, .ms._size6',
		dv: '84px',
	},
	{
		n: 'iconSize7',
		dn: 'Icon Size 7',
		de: 'Icon Size 7',
		np: true,
		cp: 'font-size',
		sel: '.fa._size7, .mi._size7, .ms._size7',
		dv: '96px',
	},
	{
		n: 'iconSize8',
		dn: 'Icon Size 8',
		de: 'Icon Size 8',
		np: true,
		cp: 'font-size',
		sel: '.fa._size8, .mi._size8, .ms._size8',
		dv: '108px',
	},

	// Global Theme
	{
		gn: 'Font',
		dn: 'Primary Font',
		n: 'primaryFont',
		dv: '14px/16px Asap',
		de: 'Primary Font used in application.',
		cp: 'font',
		sel: '._primaryFont',
		np: true,
	},
	{
		gn: 'Font',
		dn: 'Secondary Font',
		n: 'secondaryFont',
		dv: '18px/20px Asap',
		de: 'Secondary Font used in application.',
		cp: 'font',
		sel: '._secondaryFont',
		np: true,
	},
	{
		gn: 'Font',
		dn: 'Tertiary Font',
		n: 'tertiaryFont',
		dv: '16px/18px Asap',
		de: 'Tertiary Font used in application.',
		cp: 'font',
		sel: '._tertiaryFont',
		np: true,
	},
	{
		gn: 'Font',
		dn: 'Quaternary Font',
		n: 'quaternaryFont',
		dv: '12px/14px Asap',
		de: 'Quaternary Font used in application.',
		cp: 'font',
		sel: '._quaternaryFont',
		np: true,
	},
	{
		gn: 'Font',
		dn: 'Quinary Font',
		n: 'quinaryFont',
		dv: '24px/26px Asap',
		de: 'Quinary Font used in application.',
		cp: 'font',
		sel: '._quinaryFont',
		np: true,
	},

	{
		gn: 'Font',
		dn: 'Senary Font',
		n: 'senaryFont',
		dv: '30px/30px Asap',
		de: 'Senary Font used in application.',
		cp: 'font',
		sel: '._senaryFont',
		np: true,
	},

	{
		gn: 'Font Style',
		dn: 'Normal Font Style',
		n: 'normalFontStyle',
		dv: 'normal',
		de: 'Normal Font Style used in application.',
		sel: '._normalFontStyle',
		np: true,
	},
	{
		gn: 'Font Style',
		dn: 'Italic Font Style',
		n: 'italicFontStyle',
		dv: 'italic',
		de: 'Italic Font Style used in application.',
		sel: '._italicFontStyle',
		np: true,
	},
	{
		gn: 'Font Style',
		dn: 'Oblique Font Style',
		n: 'obliqueFontStyle',
		dv: 'oblique',
		de: 'oblique Font Style used in application.',
		sel: '._obliqueFontStyle',
		np: true,
	},

	{
		gn: 'Color',
		dn: 'Color One',
		n: 'colorOne',
		dv: '#52BD94',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Two',
		n: 'colorTwo',
		dv: '#08705C',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Three',
		n: 'colorThree',
		dv: '#FFC728',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Four',
		n: 'colorFour',
		dv: '#EC6B5F',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Five',
		n: 'colorFive',
		dv: '#4D7FEE',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Six',
		n: 'colorSix',
		dv: '#333333',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Seven',
		n: 'colorSeven',
		dv: '#FFFFFF',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Eight',
		n: 'colorEight',
		dv: '#8E90A4',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Nine',
		n: 'colorNine',
		dv: '#E5E5E5',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Ten',
		n: 'colorTen',
		dv: '#0085F2',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Eleven',
		n: 'colorEleven',
		dv: '#61c554',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Twelve',
		n: 'colorTwelve',
		dv: '#FE3939',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Thirteen',
		n: 'colorThirteen',
		dv: '#A3A3A3',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Fourteen',
		n: 'colorFourteen',
		dv: '#A3A3A3',
		np: true,
	},
	{
		gn: 'Color',
		dn: 'Color Fifteen',
		n: 'colorFifteen',
		dv: '#6A7FFF',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color One',
		n: 'fontColorOne',
		dv: '<colorSix>',
		de: 'Font Color One used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Two',
		n: 'fontColorTwo',
		dv: '<colorSeven>',
		de: 'Font Color Two used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Three',
		n: 'fontColorThree',
		dv: '<colorOne>',
		de: 'Font Color Three used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Four',
		n: 'fontColorFour',
		dv: '<colorTwo>',
		de: 'Font Color Four used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Five',
		n: 'fontColorFive',
		dv: '<colorThree>',
		de: 'Font Color Five used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Six',
		n: 'fontColorSix',
		dv: '<colorNine>',
		de: 'Font Color Six used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Seven',
		n: 'fontColorSeven',
		dv: '<colorFive>',
		de: 'Font Color Seven used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Eight',
		n: 'fontColorEight',
		dv: '<colorThirteen>',
		de: 'Font Color Eight used in application',
		np: true,
	},
	{
		gn: 'Font Color',
		dn: 'Font Color Nine',
		n: 'fontColorNine',
		dv: '<colorFour>',
		de: 'Font Color Nine used in application',
		np: true,
	},

	{
		gn: 'Background Color',
		dn: 'Background Color One',
		n: 'backgroundColorOne',
		dv: '<colorOne>',
		de: 'Background One used in application',
		cp: 'background',
		sel: '._PRIMARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Two',
		n: 'backgroundColorTwo',
		dv: '<colorTwo>',
		de: 'Background Two used in application',
		cp: 'background',
		sel: '._SECONDARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Three',
		n: 'backgroundColorThree',
		dv: '<colorThree>',
		de: 'Background Three used in application',
		cp: 'background',
		sel: '._TERTIARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Four',
		n: 'backgroundColorFour',
		dv: '<colorFour>',
		de: 'Background Four used in application',
		cp: 'background',
		sel: '._QUATERNARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Five',
		n: 'backgroundColorFive',
		dv: '<colorFive>',
		de: 'Background Five used in application',
		cp: 'background',
		sel: '._QUINARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Six',
		n: 'backgroundColorSix',
		dv: '<colorSix>',
		de: 'Background Six used in application',
		cp: 'background',
		sel: '._SENARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Seven',
		n: 'backgroundColorSeven',
		dv: '<colorSeven>',
		de: 'Background Seven used in application',
		cp: 'background',
		sel: '._SEPTENARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Eight',
		n: 'backgroundColorEight',
		dv: '<colorThirteen>',
		de: 'Background Eight used in application',
		cp: 'background',
		sel: '._OCTONARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Nine',
		n: 'backgroundColorNine',
		dv: '<colorNine>',
		de: 'Background Nine used in application',
		cp: 'background',
		sel: '._NONARYBG',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Color Ten',
		n: 'backgroundColorTen',
		dv: 'transparent',
		de: 'Background Ten used in application',
		np: true,
	},

	{
		gn: 'Border Color',
		dn: 'Border Color One',
		n: 'borderColorOne',
		dv: '<colorSix>',
		de: 'Border Color One used in application.',
		np: true,
	},
	{
		gn: 'Border Color',
		dn: 'Border Color Two',
		n: 'borderColorTwo',
		dv: '<colorSeven>',
		de: 'Border Color Two used in application.',
		np: true,
	},
	{
		gn: 'Border Color',
		dn: 'Border Color Three',
		n: 'borderColorThree',
		dv: '<colorOne>',
		de: 'Border Color Three used in application.',
		np: true,
	},
	{
		gn: 'Border Color',
		dn: 'Border Color Four',
		n: 'borderColorFour',
		dv: '<colorTwo>',
		de: 'Border Color Four used in application.',
		np: true,
	},
	{
		gn: 'Border Color',
		dn: 'Border Color Five',
		n: 'borderColorFive',
		dv: '<colorThree>',
		de: 'Border Color Five used in application.',
		np: true,
	},
	{
		gn: 'Border Color',
		dn: 'Border Color Six',
		n: 'borderColorSix',
		dv: '<colorNine>',
		de: 'Border Color Six used in application.',
		np: true,
	},
	{
		gn: 'Border Color',
		dn: 'Border Color Seven',
		n: 'borderColorSeven',
		dv: '<colorFive>',
		de: 'Border Color Seven used in application.',
		np: true,
	},

	{
		gn: 'Letter Spacing',
		dn: 'Letter Spacing One',
		n: 'letterSpacingOne',
		dv: 'normal',
		de: 'Letter Spacing One used in application.',
		np: true,
	},
	{
		gn: 'Letter Spacing',
		dn: 'Letter Spacing Two',
		n: 'letterSpacingTwo',
		dv: '0.16px',
		de: 'Letter Spacing Two used in application.',
		np: true,
	},

	{
		gn: 'Gradient Color',
		dn: 'Gradient Color One',
		n: 'gradientColorOne',
		dv: 'linear-gradient(90deg, <backgroundColorOne>, transparent)',
		de: 'Gradient One used in application',
		cp: 'background',
		sel: '._PRIMARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Two',
		n: 'gradientColorTwo',
		dv: 'linear-gradient(90deg, <backgroundColorTwo>, transparent)',
		de: 'Gradient Two used in application',
		cp: 'background',
		sel: '._SECONDARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Three',
		n: 'gradientColorThree',
		dv: 'linear-gradient(90deg, <backgroundColorThree>, transparent)',
		de: 'Gradient Three used in application',
		cp: 'background',
		sel: '._TERTIARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Four',
		n: 'gradientColorFour',
		dv: 'linear-gradient(90deg, <backgroundColorFour>, transparent)',
		de: 'Gradient Four used in application',
		cp: 'background',
		sel: '._QUATERNARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Five',
		n: 'gradientColorFive',
		dv: 'linear-gradient(90deg, <backgroundColorFive>, transparent)',
		de: 'Gradient Five used in application',
		cp: 'background',
		sel: '._QUINARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Six',
		n: 'gradientColorSix',
		dv: 'linear-gradient(90deg, <backgroundColorSix>, transparent)',
		de: 'Gradient Six used in application',
		cp: 'background',
		sel: '._SENARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Seven',
		n: 'gradientColorSeven',
		dv: 'linear-gradient(90deg, <backgroundColorSeven>, transparent)',
		de: 'Gradient Seven used in application',
		cp: 'background',
		sel: '._SEPTENARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Eight',
		n: 'gradientColorEight',
		dv: 'linear-gradient(90deg, <backgroundColorEight>, transparent)',
		de: 'Gradient Eight used in application',
		cp: 'background',
		sel: '._OCTONARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Nine',
		n: 'gradientColorNine',
		dv: 'linear-gradient(90deg, <backgroundColorNine>, transparent)',
		de: 'Gradient Nine used in application',
		cp: 'background',
		sel: '._NONARYGRADBG',
		np: true,
	},
	{
		gn: 'Gradient Color',
		dn: 'Gradient Color Ten',
		n: 'gradientColorTen',
		dv: 'linear-gradient(90deg, <backgroundColorTen>, transparent)',
		de: 'Gradient Ten used in application',
		np: true,
	},

	{
		gn: 'Success Color',
		dn: 'Success Color',
		n: 'successColor',
		dv: '#227700',
		np: true,
	},
	{
		gn: 'Information Color',
		dn: 'Information Color',
		n: 'informationColor',
		dv: '#059',
		np: true,
	},
	{
		gn: 'Warning Color',
		dn: 'Warning Color',
		n: 'warningColor',
		dv: '#e5d122',
		np: true,
	},
	{
		gn: 'Error Color',
		dn: 'Error Color',
		n: 'errorColor',
		dv: '#ed6a5e',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Font',
		n: 'validationMessageFont',
		dv: '<quaternaryFont>',
		cp: 'font',
		sel: '._validationMessages',
		np: true,
	},
	{
		gn: 'Validation Message',
		dn: 'Validation Message Color',
		n: 'validationMessageFontColor',
		dv: '<errorColor>',
		cp: 'color',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Text Align',
		n: 'validationMessageTextAlign',
		cp: 'textAlign',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Margin',
		n: 'validationMessageMargin',
		cp: 'margin',
		sel: '._validationMessages',
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Border Radius',
		n: 'validationMessageBorderRadius',
		cp: 'border-radius',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Border',
		n: 'validationMessageBorder',
		cp: 'border',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Width',
		n: 'validationMessageWidth',
		cp: 'width',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Inset',
		n: 'validationMessageInset',
		cp: 'inset',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Background',
		n: 'validationMessageBackgroundColor',
		cp: 'background',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Gap',
		n: 'validationMessageGap',
		dv: '3px',
		cp: 'gap',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Padding',
		n: 'validationMessagePadding',
		cp: 'padding',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Validation Message',
		dn: 'Validation Message Container Box shadow',
		n: 'validationMessageShadow',
		cp: 'box-shadow',
		sel: '._validationMessages',
		np: true,
	},

	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color One',
		n: 'backgroundHoverColorOne',
		dv: '#A8DEC9',
		de: 'Background Hover One used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Two',
		n: 'backgroundHoverColorTwo',
		dv: '#81B7AB',
		de: 'Background Hover Two used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Three',
		n: 'backgroundHoverColorThree',
		dv: '#FFE193',
		de: 'Background Hover Three used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Four',
		n: 'backgroundHoverColorFour',
		dv: '#F3B4AE',
		de: 'Background Hover Four used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Five',
		n: 'backgroundHoverColorFive',
		dv: '#A5BDF6',
		de: 'Background Hover Five used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Six',
		n: 'backgroundHoverColorSix',
		dv: '#999999',
		de: 'Background Hover Six used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Seven',
		n: 'backgroundHoverColorSeven',
		dv: '#DDDDDD',
		de: 'Background Hover Seven used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Eight',
		n: 'backgroundHoverColorEight',
		dv: '#DDDDDD',
		de: 'Background Hover Eight used in application',
		np: true,
	},
	{
		gn: 'Background Hover Color',
		dn: 'Background Hover Color Nine',
		n: 'backgroundHoverColorNine',
		dv: '#FFFFFF',
		de: 'Background Hover Nine used in application',
		np: true,
	},

	{
		gn: 'Background Color',
		dn: 'Background Darker Color One',
		n: 'backgroundDarkerColorOne',
		dv: '#1e4e3c',
		de: 'Background Darker One used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Two',
		n: 'backgroundDarkerColorTwo',
		dv: '#032d25',
		de: 'Background Darker Two used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Three',
		n: 'backgroundDarkerColorThree',
		dv: '#765700',
		de: 'Background Darker Three used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Four',
		n: 'backgroundDarkerColorFour',
		dv: '#76170e',
		de: 'Background Darker Four used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Five',
		n: 'backgroundDarkerColorFive',
		dv: '#0b2b73',
		de: 'Background Darker Five used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Six',
		n: 'backgroundDarkerColorSix',
		dv: '#141414',
		de: 'Background Darker Six used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Seven',
		n: 'backgroundDarkerColorSeven',
		dv: '#666666',
		de: 'Background Darker Seven used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Eight',
		n: 'backgroundDarkerColorEight',
		dv: '#373844',
		de: 'Background Darker Eight used in application',
		np: true,
	},
	{
		gn: 'Background Color',
		dn: 'Background Darker Color Nine',
		n: 'backgroundDarkerColorNine',
		dv: '#5c5c5c',
		de: 'Background Darker Nine used in application',
		np: true,
	},
];

export const styleDefaults = new Map<string, string>(
	styleProperties
		.filter(e => !!e.dv)
		.map(({ n: name, dv: defaultValue }) => [name, defaultValue!]),
);
